import { getTermsValue } from '@/packages/JsonQuery';
import { ERoomsTotal } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagRoomsCountSchema } from '../types';

const TEXT_MAP: { [key in ERoomsTotal]: string | null } = {
  [ERoomsTotal.Any]: null,
  [ERoomsTotal.One]: 'от 1',
  [ERoomsTotal.Two]: 'от 2',
  [ERoomsTotal.Three]: 'от 3',
  [ERoomsTotal.Four]: 'от 4',
  [ERoomsTotal.Five]: 'от 5',
};

export const roomsCount: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value: ERoomsTotal[] = getTermsValue('rooms_count')(jsonQuery) || [];

    const tagsGroup = value.reduce<TagRoomsCountSchema[]>((acc, key) => {
      const text = TEXT_MAP[key];
      if (!text) {
        return acc;
      }

      acc.push({
        group: 'roomsCount',
        text: `Комнат в квартире: ${text}`,
        data: key,
      });

      return acc;
    }, []);

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagRoomsCountSchema) {
    const currentValue = getTermsValue('rooms_count')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setRoomsCount',
      arguments: [nextValue],
    });
  },
};
